import { getWindowSize } from 'dom-helper';
import { MOBILE_WIDTH_LIMIT } from '../config/constants';

export default function isMobile() {
  const windowSize = getWindowSize();

  return windowSize.width < MOBILE_WIDTH_LIMIT;
}



// WEBPACK FOOTER //
// ./src/utils/mobile-checker.js